/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 *
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 *
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
 */

// -----------------------------TIMESERIES BLOCK -----------------------------------

import * as Blockly from 'blockly/core';
import 'blockly/python';
import { getAllowedStatements, getAllowedOutputs } from '../block_compatibility_checks';
const timeSeriesOptions = {
    'annual': [
        ["Yearly", "yearly"]
    ],
    'else': [
        ["Yearly", "yearly"],
        ["Monthly", "monthly"],
        ["Weekly", "weekly"],
        ["Daily", "daily"]
    ]
}

Blockly.Blocks['analyse_timeseries'] = {
    init: function () {

        const generateTimeseriesOptions = (function(that) {
            return function() {
                let rootBlock = that.getRootBlock()
                if(rootBlock === null) {
                    return timeSeriesOptions['else'];
                }

                let sat = rootBlock.getFieldValue("dropdown");
                if(sat === 'PALSAR' || rootBlock.type === 'input_hansen_forest_change'){
                    return timeSeriesOptions['annual'];
                }

                return timeSeriesOptions['else'];
            }
        }) (this);

        this.appendDummyInput('input')
            .appendField('Time series interval: ')
            .appendField(new Blockly.FieldDropdown(generateTimeseriesOptions), 'interval')
        this.appendStatementInput('statements').setCheck(getAllowedStatements('timeseries'));
        this.setPreviousStatement(true, 'timeseries');
        this.setNextStatement(true, getAllowedOutputs('timeseries'));
        this.setStyle('timeSeries');
        this.setTooltip(Blockly.Msg.TIMESERIES_BLOCK_TOOLTIP);
        this.setHelpUrl('');
        this.Itype = this.getFieldValue('interval')
        this.setOnChange(() => {
            if (this.Itype !== this.getFieldValue('interval')) {
                this.updateShape_()
            }
            this.Itype = this.getFieldValue('interval')
            if (this.getParent !== null) {
                this.updateShape_();
            }
        })
    },

    updateShape_: function () {

        const generateCompatibility = (function (self) {
            return function () {
                let rootBlock = self.getRootBlock()
                if (rootBlock === null) {
                    return 'timeseries';
                }

                let sat = rootBlock.type;
                if (sat === 'input_optical_data') {
                    return 'timeseries_optical';
                }
                else if (sat === 'input_radar_data') {
                    return 'timeseries_radar';
                }
                else {
                    return 'timeseries_other'
                }
            }
        })(this);
        let compatibility = generateCompatibility;
        this.getInput('statements').setCheck(getAllowedStatements(compatibility()));

    }
};